import axiosInstance from './axiosInstance';

export async function getDriverPaystub(driverId, from, to) {
  const response = await axiosInstance.get('/payments/get-driver-paystub.php', {
    params: { driver_id: driverId, from, to },
  });
  return response.data;
}

export async function emailPaystub(driverId, from, to) {
  const response = await axiosInstance.post('/payments/email-paystub.php', {
    driver_id: driverId,
    from,
    to,
  });
  return response.data;
}
